import React from "react";

export default function BiggerWhite(props) {
  // return <div className="bg-white w-full hidden lg:block">{props.children}</div>;
  return <div className="bg-white w-full rounded sm:rounded-lg">{props.children}</div>;
}
